export function massActionSetActive(massActionName, active) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                active,
                massActionName,
                type: 'MASS_ACTION_SET_ACTIVE',
            })
        );
}

export function massActionSetSelectAll(massActionName, selectAll) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                massActionName,
                selectAll,
                type: 'MASS_ACTION_SET_SELECT_ALL',
            })
        );
}

export function massActionSetChildFormData({childFormName, label, showMessage} = {}) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                childFormName,
                label,
                showMessage,
                type: 'MASS_ACTION_SET_CHILD_FORM_DATA',
            })
        );
}

export function massActionSetLastId(lastId) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                lastId,
                type: 'MASS_ACTION_SET_LAST_ID',
            })
        );
}

export function massActionSetTargets(massActionName, targets) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                massActionName,
                targets,
                type: 'MASS_ACTION_SET_TARGETS',
            })
        );
}

export function massActionAddTargets(massActionName, targets) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                massActionName,
                targets,
                type: 'MASS_ACTION_ADD_TARGETS',
            })
        );
}

export function massActionRemoveTargets(massActionName, targets) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                massActionName,
                targets,
                type: 'MASS_ACTION_REMOVE_TARGETS',
            })
        );
}

export function massActionClearTargets(massActionName) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                massActionName,
                type: 'MASS_ACTION_CLEAR_TARGETS',
            })
        );
}

export function massActionSubmit() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MASS_ACTION_SUBMIT',
            })
        );
}

export function massActionReset() {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MASS_ACTION_RESET',
            })
        );
}

export function massActionCreateAsyncMediaItemReport(serviceDataKey) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MASS_ACTION_SUBMIT_MEDIA_ITEM_ASYNC_REPORT',
                serviceDataKey,
            })
        );
}

export function massActionCreateAsyncMediaItemDuplicateTitlesReport(serviceDataKey) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'MASS_ACTION_SUBMIT_MEDIA_ITEM_DUPLICATE_TITLES_ASYNC_REPORT',
                serviceDataKey,
            })
        );
}
